/**
 * Shared metadata for the legal pages.
 *
 * PLACEHOLDERS: the constants below marked `TODO_` are NOT real legal
 * information. FunViz does not currently record a legal entity name, business
 * address, governing jurisdiction, or contact email in the codebase, so these
 * are deliberately obvious placeholders rather than invented values. They
 * render on the pages inside a highlighted `<span class="placeholder">` so
 * they cannot ship unnoticed. Fill them in (here, once) when the real details
 * are known — every legal page reads from this file.
 */

// Date the legal pages were last authored/reviewed. Update when the text
// materially changes.
export const LEGAL_LAST_UPDATED = 'August 27, 2026';

// ACCOUNTS ASSUMPTION (maintainer directive, 2026-08-27): the Terms and
// Privacy pages are written as if user accounts already exist — registration,
// authentication, account responsibilities, and the personal data those imply
// — because login is a planned, near-term feature. This is a deliberate,
// forward-looking choice, NOT a claim about the current build. As of this
// writing the app has no auth flow wired up (Cognito was removed; the top-bar
// account menu is inert) and no payment processor integrated. To avoid
// unsupported factual claims, the pages describe accounts and data handling
// generically and gate specifics (auth provider, payments, analytics) behind
// the placeholders / conditional wording below. Revisit this wording when the
// real auth and (if any) billing stack lands.
export const ACCOUNTS_ASSUMED = true;

// Whether the app currently charges for anything. No payment processor is
// integrated in the codebase today, so paid-subscription terms are written
// conditionally ("if you purchase a paid subscription") rather than as fact.
// Flip to true and fill in the real billing details once a processor is wired.
export const HAS_PAID_SUBSCRIPTIONS = false;

// --- Placeholders requiring real values before production launch ----------
export const TODO_ENTITY = '[LEGAL ENTITY NAME — TO BE PROVIDED]';
export const TODO_JURISDICTION = '[GOVERNING JURISDICTION — TO BE PROVIDED]';
export const TODO_CONTACT_EMAIL = '[CONTACT EMAIL — TO BE PROVIDED]';
